module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_30.0b6a4cd0.png";